/* ============================================================================
   Chatham — Customer account module (auth requests + order history)
   ============================================================================
   Everything a LOGGED-IN customer needs outside the store itself, kept in one
   file so the account experience can be tracked/edited independently of the
   store UI (chatham-loosegemstone-store-v2.js) and the legacy ordering code
   (chatham-loosegemstone-func.js):

     1. Account-access forms  ->  CustomerOrder/customer_request
          • #new_customer_request       — New Customer Request (registration)
          • #existing_customer_request  — Existing Customer "Request Login"
     2. Account order history table (body.active-customer / .customers-account)
          -> CustomerOrder/getCustomerdata ; Re-Order and View-Order actions
     3. View / print single order (body.page-gemstone-view-reorder)
          -> CustomerOrder/getCustomerOrderJson (Handlebars templates)

   Re-Order routes into the NEW v2 store: the server (CustomerOrder/reorder)
   copies the order into the customer's single "pending" cart, then we send them
   to the v2 store page where it rehydrates into the tray automatically.

   Requires (loaded by the theme): jQuery, `Applink` (app base URL). Section 1
   also needs Google reCAPTCHA Enterprise (grecaptcha.enterprise). Sections 2-3
   also need DataTables, Handlebars, js-cookie (Cookies), and Shopify globals
   (Shopify.customer_id, Shopify.urlParam, stringToJson). Include on any account
   page, e.g.:  {{ 'chatham-customer-request.js' | asset_url | script_tag }}
   ============================================================================ */
// Where the v2 store section is published — Re-Order sends the customer here so
// their rehydrated cart loads. Change if the store lives on a different page.
var CHATHAM_V2_STORE_URL = '/pages/chatham-lab-grown-loose-gems-store';
(function () {
  var RECAPTCHA_SITE_KEY = '6Lcni3ksAAAAAEgcNT2nf9NPLCZu1ITf-Jtl5Q1-';

  // ngrok-free serves a browser-warning page (ERR_NGROK_6024) unless the request
  // carries this header. Add it ONLY for ngrok URLs so it self-disables on the real
  // domain. Guarded so it registers once even if the store JS also installs it.
  if (window.jQuery && !window.__chathamNgrokPrefilter) {
    window.__chathamNgrokPrefilter = true;
    window.jQuery.ajaxPrefilter(function (options) {
      if (options.url && options.url.indexOf('ngrok') !== -1) {
        options.headers = options.headers || {};
        options.headers['ngrok-skip-browser-warning'] = 'true';
      }
    });
  }

  function new_customer_request(form, captchaToken) {
    // Use serializeArray + push to be safe with special characters
    var formArray = $(form).serializeArray();
    formArray.push({ name: "recaptcha_token", value: captchaToken });

    // Tell the server whether the chosen country actually has a province/state
    // list. Shopify only populates + shows the province dropdown for countries
    // that have provinces; for those without, it's emptied and hidden. The server
    // requires "state" only when this flag is "true", so no-province countries
    // aren't wrongly rejected for a blank state.
    var $prov = $(form).find('[name="state"]');
    var provinceApplicable = $prov.length > 0 && $prov.is('select') &&
                             $prov.find('option').length > 0 && $prov.is(':visible');
    formArray.push({ name: "province_required", value: provinceApplicable ? "true" : "false" });

    // Which form is this? The existing-customer "Request Login" form and the
    // "New Customer" form post to the same endpoint; this lets the server treat
    // an unknown email on the LOGIN form as "no account found" instead of
    // silently creating a blank new-customer record.
    formArray.push({ name: "request_type", value: (form && form.id === 'existing_customer_request') ? "login" : "new" });

    $('.thank-you-page').hide();

    $.ajax({
      type: "POST",
      url: Applink + 'CustomerOrder/customer_request',
      dataType: "json",
      cache: false,
      data: $.param(formArray), // This ensures the token is encoded correctly
      beforeSend: function (xhr) {
        $('body').addClass('show-loader');
        $('.thank-you-page').hide();
        $('.form_tabs_wrapper').show();
      },
    }).done(function (data) {
      $('body').removeClass('show-loader');
      console.log("Server Response:", data);

      if (data.error) {
        // If it's a reCAPTCHA fail or Duplicate Customer, handle it
        if (data.message === "Customer already created") {
          $('.form_tabs_wrapper').hide();
          $('.error-page').show();
        } else {
          // Show the error message (e.g., "Bot detected" or "Security check failed")
          alert(data.message);
        }
      } else {
        // Success path
        $('.form_tabs_wrapper').hide();
        $('.thank-you-page').show();
      }

    }).fail(function (jqXHR, textStatus, errorThrown) {
      $('body').removeClass('show-loader');
      console.error("AJAX Error:", textStatus, errorThrown);
      $('.form_tabs_wrapper').show();
      $('.thank-you-page').hide();
    });
  }
  // Exposed globally in case other theme code calls it directly.
  window.new_customer_request = new_customer_request;

  function runRecaptcha(form) {
    if (typeof grecaptcha === "undefined" || !grecaptcha.enterprise) {
      alert("reCAPTCHA failed to initialize.");
      return;
    }
    grecaptcha.enterprise.ready(function () {
      grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, { action: 'submit' })
        .then(function (token) {
          if (!token) {
            alert("reCAPTCHA failed to initialize.");
            return;
          }
          new_customer_request(form, token);
        });
    });
  }

  // Delegated so binding is independent of when this script loads relative to
  // the forms (the old top-level binds required the form to already exist).
  $(document).on('submit', '#new_customer_request', function (e) {
    e.preventDefault();
    runRecaptcha(this);
  });
  $(document).on('submit', '#existing_customer_request', function (e) {
    e.preventDefault();
    runRecaptcha(this);
  });

  /* ==========================================================================
     2) ACCOUNT ORDER HISTORY  (body.active-customer / .customers-account)
     ========================================================================== */
  if ($('body').hasClass('active-customer')) {

    function getCustomerOrderData(id) {
      $.ajax({
        url: Applink + 'CustomerOrder/getCustomerdata?id=' + id,
        dataType: 'json',
        crossDomain: true,
        beforeSend: function (xhr) {
          $('body').addClass('show-loader');
          $('.thank-you-page').hide();
        },
        success: function (json) {
          var orders = json;
          var $tr = "";
          $('body').removeClass('show-loader');
          if (orders.length == 0 && typeof shopify_order_count !== 'undefined' && shopify_order_count == 0) {
            $("#no_orders_msg").removeClass('hidden')
          }
          if (orders.length > 0) {
            for (var i = 0; i < orders.length; i++) {
              var idStr = 'id=' + orders[i]["order_id"] + '&customer_id=' + orders[i]["customer_id"] + '';
              var encoded_id = btoa(encodeURI(idStr));
              var s = orders[i]["date_updated"];
              if (s != null) {
                var dt = Number(s.substring(6, s.lastIndexOf(')')))
              }
              else {
                s = orders[i]["date_added"];
                var dt = Number(s.substring(6, s.lastIndexOf(')')))
              }
              var newDate = new Date(dt);
              var date = newDate.toJSON().slice(0, 10);
              var nDate = date.slice(5, 7) + '/' + date.slice(8, 10) + '/' + date.slice(0, 4);
              $tr += `<tr><td><a data-id="${orders[i]["order_id"]}" href="/pages/gemstone-view-reorder?id=${encoded_id}" target="_blank" data-email="${orders[i]["customer_email"]}" data-action="view-order">${orders[i]["order_id"]}</a></td><td>${orders[i]["customer_name"]}</td><td><b>Email:</b> ${orders[i]["customer_email"]}<br><b>Preferred Method of Contact:</b>${orders[i]["contact_method"]}<br><b>Phone:</b>${orders[i]["contact_phone"]}</td>`;
              $tr += `<td>${orders[i]["shipping_method"]}</td>`;
              $tr += `<td>${orders[i]["status"]}</td><td>${nDate}</td><td><a data-id="${orders[i]["order_id"]}" href="/pages/gemstone-view-reorder?id=${encoded_id}" target="_blank" data-email="${orders[i]["customer_email"]}" data-action="view-order">View/Re-Order</a></td></tr>`;
            }
            $(".customer-orders table>tbody").empty().append($tr);
            $('.customer-orders').show();
            $('p#native-no-orders-msg').hide();
            $(".customer-orders table").DataTable({
              responsive: true,
              dom: 'Bflrtip', pageLength: 50
            });
          }
          else {
            $('.customer-orders').hide();
          }
        },
        error: function (e) {
          console.log(e);
        }
      });
    }

    if ($('body').hasClass('customers-account')) {
      getCustomerOrderData(Shopify.customer_id);
    }

    // Re-Order: the server copies the order into this customer's single "pending"
    // cart (CustomerOrder/reorder), then we send them to the v2 store, which
    // rehydrates that pending cart into its tray on load (no id needed in URL).
    $(document).on('click', '[data-action="reorder"]', function (e) {
      var id = $(this).attr('data-id'), email = $(this).attr('data-email');
      $.ajax({
        type: "POST",
        url: Applink + 'CustomerOrder/reorder',
        dataType: "json",
        cache: false,
        data: { id: id, email: email },
        beforeSend: function (xhr) {
          $('body').addClass('show-loader');
        },
      }).done(function (data) {
        $('body').removeClass('show-loader');
        if (data != null || data != undefined) {
          window.location.href = CHATHAM_V2_STORE_URL;
        }
      });
    });

    $(document).on('click', '[data-action="view-order"]', function (e) {
      var id = $(this).attr('data-id'), email = $(this).attr('data-email');
      if (id && email) {
        Cookies.set('viewoeder_clicked', true, { expires: 1, path: '/' });
      }
    });
  }

  /* ==========================================================================
     3) VIEW / PRINT SINGLE ORDER  (body.page-gemstone-view-reorder)
     ========================================================================== */
  if ($('body').hasClass('page-gemstone-view-reorder')) {

    function loadDataTable() {
      return $("#datatable-products").DataTable({
        dom: "Bfrtip",
        responsive: true,
        language: {
          processing: '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span>'
        },
        filter: true,
        pageLength: 50,
        buttons: [
          { extend: "copy", className: "btn-sm" },
          { extend: "csv", className: "btn-sm" },
          { extend: "excel", className: "btn-sm" },
          { extend: "pdfHtml5", className: "btn-sm" },
          { extend: "print", className: "btn-sm" }
        ]
      });
    }

    $(document).ready(function () {
      Handlebars.registerHelper("inc", function (value, options) {
        return parseInt(value) + 1;
      });
      Handlebars.registerHelper("math", function (lvalue, operator, rvalue, options) {
        lvalue = parseFloat(lvalue);
        rvalue = parseFloat(rvalue);
        return {
          "+": lvalue + rvalue,
          "-": lvalue - rvalue,
          "*": lvalue * rvalue,
          "/": lvalue / rvalue,
          "%": lvalue % rvalue
        }[operator];
      });
      Handlebars.registerHelper('safeColorMatchCost', function (colorMatchCost, fallbackValue) {
        return (colorMatchCost == null || isNaN(colorMatchCost)) ? fallbackValue : colorMatchCost;
      });

      var get_encodedId = Shopify.urlParam('id');
      var viewoeder_clicked = Cookies.get('viewoeder_clicked');
      if (viewoeder_clicked != undefined) {
        if (get_encodedId.length > 0 && JSON.parse(viewoeder_clicked) == true) {
          var decodedParams = decodeURI(atob(get_encodedId))
          var jsonArray = stringToJson(decodedParams);

          $.ajax({
            url: Applink + 'CustomerOrder/getCustomerOrderJson?id=' + jsonArray.id + '&customer_id=' + jsonArray.customer_id,
            dataType: 'json',
            crossDomain: true,
            beforeSend: function (xhr) {
              $('body').addClass('show-loader');
            },
            success: function (data) {
              $('body').removeClass('show-loader');
              var orderDetails;
              $('[data-action="reorder"]').attr('data-id', data.customerOrder.order_id);
              $('[data-action="reorder"]').attr('data-email', data.customerOrder.customer_email);
              if (data.orderDetails) {
                orderDetails = data.orderDetails;
              }
              var templateSource = $("#order_table_template").html();
              var template = Handlebars.compile(templateSource);
              var studentHTML = template({ items: orderDetails });
              $('#datatable-products tbody').html(studentHTML);

              templateSource = $("#customer_info_table_template").html();
              template = Handlebars.compile(templateSource);
              studentHTML = template({ model: data });
              $('#customer_info_table').html(studentHTML);

              templateSource = $("#shipping_info_table_template").html();
              template = Handlebars.compile(templateSource);
              studentHTML = template({ model: data });
              $('#shipping_info_table').html(studentHTML);

              loadDataTable();
            },
          })
        }
      }
      else {
        location.href = '/account';
      }
    })
  }
})();
